module.exports = __webpack_public_path__ + "static/media/closex.78682fc2.svg";